const cartSubDirectory = "/Cart";

export const getCartItems = `${cartSubDirectory}/GetCartItems`;
export const makePayment = `${cartSubDirectory}/MakePayment`;
